import { z } from 'zod'

/**
 * `LGH-039`. Wire shape transcribed from `REQ-platform-core-the-commercial-
 * rules-shape-for-console`'s own answer — live-verified there, not a
 * contract file this repo can read (`customer-app` isn't in Lighthouse's
 * whitelist).
 *
 * **Every field is a string or `null`, never a number.** Money and fraction
 * values on this estate's wire are always strings — a JSON number silently
 * loses the precision a `Decimal` column does not. `null` means genuinely
 * undeclared (`R-079`), not zero and not "no limit" — the console must not
 * invent a default for an absent value.
 *
 * The three percent fields are fractions of one (`"0.15"` = 15%), refused
 * server-side at or past `1` — the console does not re-validate that range,
 * it displays and submits the string the server already owns the rule for.
 */
export const tenantCommercialRulesSchema = z
  .object({
    creditLimitDefault: z.string().nullable(),
    marginFloorPercent: z.string().nullable(),
    discountFloorPercent: z.string().nullable(),
    defaultMarkupPercent: z.string().nullable(),
  })
  .strict()
export type TenantCommercialRules = z.infer<typeof tenantCommercialRulesSchema>
